import { Clock } from "lucide-react";
import { getPastRelativeTime } from "functions/deviceStatusUtils";

interface ValueCardProps {
    label: string;
    value?: string;
    color: string;
    timestamp?: string | null | undefined;
}

export const ViewMgtDeviceStatusValue = ({ label, value, color, timestamp }: ValueCardProps) => (
    <div className="p-3">
        <div className="flex items-center gap-2">
            <div className="flex-1">
                <div className="text-xs text-slate-500">{label}</div>
                <div className={`text-sm font-bold font-medium ${color}`}>{timestamp ? value : "-"}</div>
            </div>
            <div className="text-xs text-slate-500 flex items-center gap-1">
                { timestamp && timestamp !== "-" ? <><Clock size={14} />{getPastRelativeTime(timestamp)}</> : "-" }
            </div>
        </div>
    </div>
);